import { CellClickedEvent } from 'ag-grid-community';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useCallback } from 'react';
import BalanceGridRow from './types';
import { selectAccountHistory } from 'actions/accountsActions';
import history from 'constants/history';
import { CLICKABLE_CELLS } from './columnDefs';

type UseOnCellClickArgs = {
  balances?: boolean;
};

const useOnCellClick = ({ balances = false }: UseOnCellClickArgs = {}) => {
  const dispatch = useAppDispatch();
  const onCellClicked = useCallback(
    (event: CellClickedEvent<BalanceGridRow>) => {
      const colId = event.column.getColId();
      if (CLICKABLE_CELLS.includes(colId)) {
        // Skip common cell click for already clickable cells
        return;
      }
      // Common click functionality
      const id = event?.data?.accountId;
      if (id) {
        dispatch(selectAccountHistory(Number(id)));
        history.push(`/${balances ? 'balances' : 'clearing_accounts'}/${id}`);
      }
    },
    [balances, dispatch],
  );

  return onCellClicked;
};

export default useOnCellClick;
